interface StringFilterOptions<T> {
  filterValue: string;
  attributesToFilterOn: (keyof T)[];
}

export function stringFilter<T extends {[key: string]: any}>(
  objectsToFilter: T[],
  {filterValue, attributesToFilterOn}: StringFilterOptions<T>,
) {
  const lowerCaseFilterVal = filterValue.toLocaleLowerCase();

  return objectsToFilter.filter((obj: T) => {
    return attributesToFilterOn.some((filterAttribute) => {
      const filteredAttrVal = obj[filterAttribute].toLowerCase();
      return filteredAttrVal.indexOf(lowerCaseFilterVal) > -1;
    });
  });
}
